import env from "../../environment";
import { filtrarMenu, etiquetaParcelas} from "../content/coop-config";
const Menu = [
  {
    path: "/dashboard",
    icon: "fa fa-home",
    title: "Inicio",
    permission: "PADRON",
    coopconfig: { variable: "mostrar_dashboard_inicio", cond: "=", value: 1 },
  },
  {
    path: "/admin/cuentas",
    icon: "fa fa-user-circle",
    title: "Productores",
    permission: "CUENTAS",
    coopconfig2: "noMostrarProductoresDashboardCambiarPath",
    children: [
      {
        path: "/admin/cuentas/list",
        title: "Listado productores",
        permission: "CUENTAS",
      },
    ],
  },
  {
    path: "/admin/parcelas",
    icon: "fa fa-map-marker",
    title: `${etiquetaParcelas(['plural', 'capitalize'])}`,
    coopconfig: { variable: "usa_sic", cond: "=", value: "1" },
    permission: "PARCELAS",
    children: [
      {
        path: "/admin/parcelas/list",
        title: `Listado ${etiquetaParcelas(['plural', 'lowercase'])}`,
        permission: "PARCELAS",
      },
    ],
  },
  {
    path: "/admin/padron/completo/list",
    icon: "fa fa-file",
    title: "Padrón",
    permission: "PADRON",
    coopconfig: { variable: "usa_sic", cond: "=", value: "1" },
    coopconfig2: "noMostrarPadronCambiarPath",
    badgeType: "bell",
    badgeIcon: "fa fa-bell text-warning ml-2",
    badgeData: "padronAltas",
    children: [
      {
        path: "/admin/padron/completo/list",
        title: "Completo",
        permission: "PADRON_COMPLETO",
        coopconfig: {
          variable: "mostrar_padron_completo",
          cond: "=",
          value: 1,
        },
      },
      {
        path: "/admin/padron/concentrado/list",
        title: "Concentrado",
        permission: "PADRON_CONCENTRADO",
        coopconfig: {
          variable: "mostrar_padron_concentrado",
          cond: "=",
          value: 1,
        },
      },
      {
        path: "/admin/padron/altas/list",
        title: "Altas",
        permission: "PADRON_ALTAS",
        badgeData: "padronAltas",
        badgeType: "badge",
      },
      {
        path: "/admin/padron/bajas/list",
        title: "Bajas",
        permission: "PADRON_BAJAS",
      },
      {
        path: "/admin/padron/mapas/list",
        title: "Mapas",
        permission: "PADRON_MAPAS",
      },
      {
        path: "/reportes/personalizados/list",
        title: "Reportes Personalizados",
      },
    ],
  },
  {
    path: "/admin/acopio",
    icon: "fa fa-store",
    title: "Acopio",
    permission: "ACOPIOS",
    coopconfig: { variable: "usa_acopio", cond: "=", value: "1" },
    children: [
      {
        path: "/admin/acopio/acopio_por_productor/list",
        title: "Por productor",
        permission: "ACOPIOS_X_PRODUCTOR",
      },
      {
        path: "/admin/acopio/entregas_por_productor/list",
        title: "Entregas",
        permission: "ACOPIOS_ENTREGAS_X_PRODUCTOR",
      },
      // {
      //   path: "/admin/acopio/entregas_por_productor/seleccion",
      //   title: "Nueva entrega",
      //   permission: "ACOPIOS_ENTREGAS_X_PRODUCTOR",
      // },
      {
        path: "/admin/acopio/anticipos_por_productor/list",
        title: "Créditos",
        permission: "ACOPIOS_ANTICIPOS_X_PRODUCTOR",
        coopconfig: {
          variable: "id_cat_credito_precosecha",
          cond: ">=",
          value: "2",
        },
        coopconfig2: "mostrarCreditoPrecosecha",
      },
      {
        path: "/admin/acopio/entregas_efectivo/list",
        title: "Efectivo",
        permission: "ACOPIOS_ENTREGAS_EFECTIVO",
      },
      {
        path: "/admin/acopio/remanente/list",
        title: "Remanente",
        permission: "ACOPIOS_X_PRODUCTOR",
        coopconfig: {
          variable: "remanente_tipo",
          cond: ">",
          value: "0",
        },
      },
      {
        path: "/admin/acopio/precio_por_cooperativa/list",
        title: "Precio",
        permission: "ACOPIOS_PRECIO_X_COOPERATIVA",
      },
      {
        path: "/admin/acopio/lotes",
        title: "Lotes",
        permission: "ACOPIOS_PRECIO_X_COOPERATIVA",
      },
    ],
  },
  {
    path: "/admin/calidad",
    icon: "fa fa-check",
    title: "Calidad",
    permission: "ACOPIOS",
    coopconfig: { variable: "usa_calidad", cond: "=", value: "1" },
  },
  {
    path: "/admin/cooperativas/list",
    icon: "fa fa-building",
    title: "Cooperativas",
    permission: "COOPERATIVAS",
    children: [
      {
        path: "/admin/cooperativas/uso-sirio",
        title: "Uso de Sirio",
        permission: "COOPERATIVAS",
      },
      {
        path: "/admin/cooperativas/reporte-general",
        title: "Reporte general",
        permission: "COOPERATIVAS",
      },
    ],
  },
  {
    path: "/admin/usuarios/list",
    icon: "fa fa-users",
    title: "Usuarios",
    permission: "USUARIOS",
  },
  // // TODO: add permission! VINCULAR_SIC
  // {
  //   path: '/admin/vincular-sic/list',
  //   icon: 'fa fa-link',
  //   title: 'Vincular SIC',
  //   permission: 'LOCALIDADES',
  //   children: [
  //     {
  //       path: '/admin/vincular-sic/list',
  //       icon: 'fa fa-user-circle',
  //       title: 'Productores',
  //       permission: 'LOCALIDADES',
  //     },
  //     {
  //       path: '/admin/vincular-sic-parcelas/list',
  //       icon: 'fa fa-map-marker',
  //       title: 'Parcelas',
  //       permission: 'LOCALIDADES',
  //     },
  //   ],
  // },

  // { path: '/admin/csv/list', icon: 'fa fa-table', title: 'CSV', permission: 'CSV' },
  // { path: '/admin/localidades/list', icon: 'fa fa-map-marker', title: 'Localidades', permission: 'LOCALIDADES' },
  {
    path: "/admin/versiones/list",
    icon: "fa fa-cogs",
    title: "Versiones",
    permission: "VERSIONES",
  },
  {
    path: "/admin/calidad-de-datos",
    icon: "fa fa-gamepad",
    title: "Calidad de datos",
    permission: "USUARIOS",
  },
  {
    path: "/admin/ficha/master/lista",
    icon: "fa fa-list",
    title: "Ficha Master",
    permission: "FICHAS_ODK_VER",
  },
  {
    path: "/admin/formulario/master",
    icon: "fa fa-list",
    title: "Formulario Master",
    permission: "FICHAS_ODK_VER",
  },
  {
    path: "/admin/tokens/list",
    icon: "fa fa-key",
    title: "Tokens externos",
    permission: "TOKENS_EXTERNOS",
  },
];

export default filtrarMenu(Menu);
